<div class="login-container">
  <div class="login-wrapper">
    <!-- Lado esquerdo - Imagem -->
    <div class="login-image-section">
      <div class="image-overlay"></div>
    </div>

    <!-- Lado direito - Formulário -->
    <div class="login-form-section">
      <div class="form-container">
        <!-- Logo -->
        <div class="logo-section">
          <img src="assets/branding/flit-core-logo-light.svg" alt="Flit Core" class="company-logo">
        </div>

        <!-- Card de Perfil do Último Usuário -->
        <div class="user-profile-card" *ngIf="lastLoggedEmail">
          <div class="user-avatar" [class.has-image]="lastLoggedAvatar">
            <img *ngIf="lastLoggedAvatar" [src]="lastLoggedAvatar" alt="Avatar" class="avatar-img">
            <span *ngIf="!lastLoggedAvatar" class="avatar-initials">{{ getUserInitials() }}</span>
          </div>
          <div class="user-info">
            <div class="user-name">{{ lastLoggedUsername || 'Usuário' }}</div>
            <div class="user-email">{{ lastLoggedEmail }}</div>
          </div>
          <button type="button" class="remove-user-btn" (click)="removeLastLoggedEmail()" title="Remover usuário">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="3 6 5 6 21 6"></polyline>
              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
              <line x1="10" y1="11" x2="10" y2="17"></line>
              <line x1="14" y1="11" x2="14" y2="17"></line>
            </svg>
          </button>
        </div>

        <!-- Formulário de Login -->
        <div class="login-form">
          <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <!-- Campo Email -->
            <div class="input-group" *ngIf="!lastLoggedEmail">
              <label for="email" class="input-label">Email</label>
              <input
                type="email"
                id="email"
                class="form-input"
                formControlName="email"
                [class.error]="submitted && f['email'].errors"
                placeholder="Email"
              />
              <div *ngIf="submitted && f['email'].errors" class="error-message">
                <span *ngIf="f['email'].errors['required']">O email é obrigatório</span>
                <span *ngIf="f['email'].errors['email']">Email inválido</span>
              </div>
            </div>

            <!-- Campo Senha -->
            <div class="input-group">
              <div class="password-wrapper">
                <input
                  [type]="showPassword ? 'text' : 'password'"
                  id="password"
                  class="form-input"
                  formControlName="password"
                  [class.error]="submitted && f['password'].errors"
                  placeholder="Senha"
                />
                <button
                  type="button"
                  class="toggle-password-btn"
                  (click)="showPassword = !showPassword"
                  [title]="showPassword ? 'Ocultar senha' : 'Exibir senha'"
                >
                  <svg *ngIf="!showPassword" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                  <svg *ngIf="showPassword" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                    <line x1="1" y1="1" x2="23" y2="23"></line>
                  </svg>
                </button>
              </div>
              <div *ngIf="submitted && f['password'].errors" class="error-message">
                A senha é obrigatória
              </div>
            </div>

            <!-- Captcha -->
            <div class="checkbox-group">
              <label class="checkbox-container">
                <input
                  type="checkbox"
                  class="checkbox-input"
                  formControlName="captcha"
                />
                <span class="checkbox-text">Não sou um robô</span>
              </label>
              <a (click)="openForgotPasswordModal()" class="forgot-password">Esqueci minha senha</a>
            </div>
            <div *ngIf="submitted && f['captcha'].errors" class="error-message captcha-error">
              Selecione "Não sou um robô" para continuar
            </div>

            <!-- Mensagem de Erro -->
            <div *ngIf="error" class="alert-error">
              {{ error }}
            </div>

            <!-- Botão Entrar -->
            <button
              type="submit"
              class="login-button"
              [disabled]="loading"
            >
              <span *ngIf="loading" class="loading-spinner"></span>
              {{ loading ? 'ENTRANDO...' : 'ENTRAR' }}
            </button>
          </form>
        </div>

        <!-- Footer -->
        <div class="login-footer">
          <div class="footer-text">
            <strong>Flit Core</strong> — Gestão de processos e controle de ativos
          </div>
          <div class="version-text">
            Versão 1.0.0 - Direitos Reservados
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal de Esqueci Minha Senha -->
<div class="modal-overlay" *ngIf="showForgotPasswordModal" (click)="closeForgotPasswordModal()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2 class="modal-title">Recuperar Senha</h2>
      <button type="button" class="modal-close" (click)="closeForgotPasswordModal()">
        <span>&times;</span>
      </button>
    </div>

    <div class="modal-body">
      <p class="modal-description">
        Digite seu email para receber as instruções de recuperação de senha.
      </p>

      <form [formGroup]="forgotPasswordForm" (ngSubmit)="onForgotPasswordSubmit()">
        <div class="input-group">
          <label for="forgot-email" class="input-label">Email</label>
          <input
            type="email"
            id="forgot-email"
            class="form-input"
            formControlName="email"
            [class.error]="forgotPasswordSubmitted && fp['email'].errors"
            placeholder="Digite seu email"
          />
          <div *ngIf="forgotPasswordSubmitted && fp['email'].errors" class="error-message">
            <span *ngIf="fp['email'].errors['required']">O email é obrigatório</span>
            <span *ngIf="fp['email'].errors['email']">Email inválido</span>
          </div>
        </div>

        <!-- Mensagem de sucesso -->
        <div *ngIf="forgotPasswordMessage" class="alert-success">
          {{ forgotPasswordMessage }}
        </div>

        <!-- Mensagem de erro -->
        <div *ngIf="forgotPasswordError" class="alert-error">
          {{ forgotPasswordError }}
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn-secondary"
            (click)="closeForgotPasswordModal()"
            [disabled]="forgotPasswordLoading"
          >
            Cancelar
          </button>
          <button
            type="button"
            class="btn-secondary"
            (click)="navigateToResetPasswordCode()"
            [disabled]="!isForgotPasswordEmailValid || forgotPasswordLoading"
          >
            Já possuo um Código
          </button>
          <button
            type="submit"
            class="btn-primary"
            [disabled]="forgotPasswordLoading"
          >
            <span *ngIf="forgotPasswordLoading" class="loading-spinner"></span>
            {{ forgotPasswordLoading ? 'Enviando...' : 'Enviar' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>